<template>
  <section class="dm-meta-section" :style="{ backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none' }">
    <Header :openChannelId="channelId" />

    <div class="meta-cards-container" v-show="activityData.property && !showSpinner">
      <div class="meta-activity-card" v-for="(act, k) in entities" :key="k" :style="{ backgroundImage: setCardImage(act), visibility: showSpinner ? 'hidden' : 'visible', paddingBottom: showSpinner ? '33.3%' : imageRatioString }">
        <div class="meta-activity-card-overlay">
          <p class="card-title">{{ act.activity.activity }}</p>
          <!-- <p class="card-description">{{act.activity.description}}</p> -->
          <div class="stats-btn">
            <p v-if="act.entities.length">{{ act.entities.length }} listening</p>
          </div>
          <div class="avatars">
            <div class="avatar-cell" v-for="ent in act.entities.length < 5 ? act.entities : act.entities.slice(0, 5)" :key="ent.meta_id" @click.prevent="avatarClicked(ent.properties.user)">
              <img :title="ent.properties.user.name" :src="ent.properties.user.image" />
              <!-- <label v-if="ent.properties.user.name">{{ent.properties.user.name}}</label> -->
            </div>
            <button class="button" @click.prevent="apiPostMeta(act)">ENTRAR</button>
          </div>
        </div>
      </div>
    </div>

    <div class="dm-network-widget">
      <div class="dm-network-widget-close-btn" @click.prevent="showUsersList = false" v-if="showUsersList">CLOSE</div>
      <transition name="translate-up">
        <div class="dm-network-widget-user-list-container" v-show="showUsersList">
          <div class="dm-network-widget-user" v-for="user in users" :key="user.user_id" @click.prevent="avatarClicked(user)">
            <img :title="user.name" :src="user.image" />
            <div class="dm-network-widget-user-texts">
              <p class="user-name">{{ user.name }}</p>
              <p class="user-role">{{ user.role }}</p>
            </div>
          </div>
        </div>
      </transition>
      <div class="dm-network-widget-invoker-btn" :style="{ background: showUsersList ? '#444' : 'none' }">
        <i class="fas fa-users" @click.prevent="openUsersList"></i>
      </div>
    </div>

    <div class="meta-modal-container" v-show="showModal" @click.prevent="closeModal">
      <iframe id="zoomIframe" style="width: 100%; height: 100%" :src="zoomSrc" allow="camera; microphone; fullscreen" frameborder="0" v-show="showZoomIframe"></iframe>
      <div class="meta-user-profile-container" v-show="!showZoomIframe">
        <img :src="currentUser.image" v-if="currentUser && currentUser.image" />
        <label v-if="currentUser && currentUser.name">{{ currentUser.name }}</label>
        <button class="button" @click.stop="openChannel(currentUser.user_id)">MENSAGEM</button>
      </div>
    </div>

    <Spinner :showSpinner="showSpinner" style="background: #0007; height: 100%; padding-top: 20%" />
    <Footer style="z-index: 0" />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api';
import Spinner from '@/components/ui/Spinner.vue';
import DefaultAvatar from '@/assets/img/default_avatar.png';

export default {
  name: 'DynamicMeetings',

  components: {
    Header,
    Footer,
    Spinner,
  },

  data() {
    return {
      activityData: { images: { bg: '' } },
      baseImg: '',
      entities: [],
      meta: [],
      activityID: '10f98ad0-ac51-11eb-9fc3-cb273085eff7',
      metaLoaded: false,
      loadedImagesCount: 0,
      showModal: false,
      showZoomIframe: false,
      showSpinner: false,
      currentEntityID: '',
      currentMetaID: '',
      currentUser: null,
      updaterInterval: null,
      channelId: '',
      zoomSrc: 'https://meet-zoom.blitzar.com.br',
      imageRatioString: '33.3%',
      isMobile: false,
      showUsersList: false,
      users: [],
      itensPerPage: 50,
      paginationCount: 0,
      userSearch: '',
    };
  },

  methods: {
    loadActivity(isReload) {
      if (!isReload) this.showSpinner = true;
      api
        .get(`activity/${this.$route.params.stream}`)
        .then((response) => {
          this.activityData = { ...this.activityData, ...response.data };
          this.activityData.images = JSON.parse(this.activityData.images);
          this.activityData.property = JSON.parse(this.activityData.property);

          this.apiGetMetaConfigs();
        })

        .catch((err) => {
          console.error(err);
        });
    },
    apiGetMetaConfigs() {
      api
        .get(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/metaConfig`)
        .then(async (response) => {
          // console.log('apiGetMetaConfigs response: ', { response });
          this.entities = await Promise.all(
            response.data
              .filter((e) => e.conference)
              .map(async (entity) => {
                entity.activity = await this.loadMetaActivity(entity.conference);
                entity.activity.images = JSON.parse(entity.activity.images);
                entity.entities = await this.apiGetMeta(entity.activity.activity_id);
                entity.entities.map((item) => (item.properties = JSON.parse(item.properties)));
                return entity;
              }),
          );
          // this.showSpinner = false;
        })
        .catch((err) => console.error(err));
    },
    loadMetaActivity(id) {
      return new Promise((resolve, reject) => {
        // console.log('loadMetaActivity', id);
        api
          .get(`activity/${id}`)
          .then((response) => {
            resolve(response.data);
          })

          .catch((err) => {
            console.error(err);
            reject();
          });
      });
    },
    apiGetMeta(conference_id) {
      return new Promise((resolve, reject) => {
        api
          .get(`event/${this.$store.state.eventId}/activity/${conference_id}/meta`)
          .then((response) => {
            // console.log('apiGetMeta response: ', conference_id, { response });
            resolve(response.data);
            this.metaLoaded = true;
          })
          .catch((err) => {
            console.error(err);
            reject();
          });
      });
    },
    apiPostMeta(act) {
      if (this.currentMetaID) return;
      let payload = {
        position: this.$RNG.randomID(),
        properties: JSON.stringify({
          user: {
            user_id: this.$store.state.user.id,
            name: this.$store.state.user.name,
            image: this.$store.state.user.picture,
          },
        }),
      };
      api
        .post(`event/${this.$store.state.eventId}/activity/${act.conference}/meta/`, payload)
        .then((response) => {
          // console.log('apiPostMeta ADD USER response: ', { response });
          this.currentMetaID = response.data.meta_id;

          let meeetLink = JSON.parse(act.activity.property).meetLink;
          if (meeetLink.includes('talk.blitzar.com.br')) {
            let roomId = meeetLink.split('talk.blitzar.com.br/')[1];
            console.log('postMeta: ', roomId ? roomId : 'public_room');
            this.$root.$emit('joinBlitzarMeeting', roomId ? roomId : 'public_room');
            this.apiGetMetaConfigs();
            return;
          }
          this.showZoomIframe = true;
          this.joinZoomMeeting(act.activity);
          this.showModal = !this.showModal;
          this.apiGetMetaConfigs();
        })
        .catch((err) => console.error(err));
    },
    apiPutMeta(meta) {
      let payload = {
        properties: JSON.stringify({
          user: {
            user_id: this.$store.state.user.id,
            name: this.$store.state.user.name,
            image: this.$store.state.user.picture,
            email: null,
            telephone: null,
            company: null,
            role: null,
            nickname: null,
            about_me: null,
            link: null,
            other: null,
          },
        }),
      };
      api
        .put(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta/${meta.meta_id}`, payload)
        .then((response) => {
          // console.log('apiPutMeta response: ', { response });
        })
        .catch((err) => console.error(err));
    },
    apiDeleteMeta(meta) {
      api
        .delete(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta/${meta.meta_id}`)
        .then((response) => {
          // console.log('apiDeleteMeta response: ', { response });
        })
        .catch((err) => console.error(err));
    },
    apiGetUsers() {
      return new Promise((resolve, reject) => {
        api
          .get(`event/${this.$store.state.eventId}/userSearch?limit=${this.itensPerPage}&page=${this.paginationCount}`)
          .then((response) => {
            // console.log('Users= ', { response });
            if (response.data) {
              let users = [];
              response.data.userExists.map((item) => {
                // console.log('getUsers', { item });
                users.push({
                  image: item.image ? item.image : DefaultAvatar,
                  name: item.name ? item.name : item.email,
                  role: `${item.role ?? ''} ${item.role && item.company ? ' - ' : ''} ${item.company ?? ''} ${(item.role || item.company) && item.city ? ' - ' : ''} ${item.city ? item.city : ''} ${item.state ? ' - ' + item.state : ''} ${
                    item.about_me ? ' - ' + item.about_me : ''
                  }`,
                  other: item.other ?? '',
                  action: 'MENSAGEM',
                  actionType: 'talk',
                  enableAction: true,
                  url: item.user_id > this.$store.state.user.id ? item.user_id + this.$store.state.user.id : this.$store.state.user.id + item.user_id,
                  target: item.user_id,
                  enableAction: item.user_id != this.$store.state.user.id,
                  public_events: item.public_events ? parseInt(item.public_events) : 0,
                });
              });
              this.users = [...users];
              resolve();
            }
          })
          .catch((err) => console.error(err));
      });
    },
    avatarClicked(user) {
      this.currentUser = user;
      this.showModal = !this.showModal;
    },
    clickModal() {
      console.log('clickModal');
    },
    messageReceiver(e) {
      // console.log('messageReceiver', e.data);
      if (e.data.meetingReady != undefined && !e.data.meetingReady) {
        this.closeModal();
      }
    },
    joinZoomMeeting(activity) {
      this.showZoomIframe = true;
      let zoomURL = JSON.parse(activity.property).meetLink;
      this.$nextTick((_) => {
        document.getElementById('zoomIframe').contentWindow.postMessage(
          {
            sender: 'conference',
            user: this.$store.state.user.name,
            language: 'pt-PT',
            msg: zoomURL ? zoomURL : 'https://zoom.us/j/97898388259?pwd=dEF0cmZQNWliZlZodjcwQWRZZWdkQT09', //ZOOM Meeting URL
          },
          '*',
        );
      });
    },
    getZoomURLFromActivity(activity_id) {
      api
        .get(`activity/${activity_id}`)
        .then((response) => {
          console.log('getZoomURLFromActivity response', { response });
        })
        .catch(() => {});
    },
    closeWindowConfirm(evt) {
      if (this.showZoomIframe) {
        this.closeModal();
        const unsaved_changes_warning = 'Você ainda tem uma sessão aberta. Deseja encerrar?';
        evt.returnValue = unsaved_changes_warning;
        return 'Você ainda tem uma sessão aberta. Deseja encerrar?';
      }
    },
    closeModal() {
      console.log('closeModal');

      if (this.showZoomIframe) {
        api
          .delete(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta/${this.currentMetaID}`)
          .then((response) => {
            console.log('apiDeleteMeta REMOVE USER response: ', { response });

            document.getElementById('zoomIframe').contentWindow.postMessage(
              {
                sender: 'logout',
                user: this.$store.state.user.name,
                language: 'pt-PT',
                msg: 'logout',
              },
              '*',
            );
            let tempZoomSrc = this.zoomSrc;
            this.zoomSrc = '';
            this.$nextTick((_) => {
              this.zoomSrc = tempZoomSrc;
              this.currentEntityID = '';
              this.showZoomIframe = false;
              this.showModal = false;
              this.apiGetMetaConfigs();
            });
          })
          .catch((err) => console.error(err));
      } else {
        this.currentEntityID = '';
        this.currentMetaID = '';
        this.currentUser = null;
        this.showZoomIframe = false;
        this.showModal = false;
      }
    },
    openChannel(user_id) {
      // console.log('open channel selectedItem link', this.selectedItem.link);
      api
        .post(`event/${this.$store.state.eventId}/createTalkChannel`, { user_id: user_id, channelName: user_id > this.$store.state.user.id ? user_id + this.$store.state.user.id : this.$store.state.user.id + user_id })
        .then((response) => {
          // console.log('createTalkChannel', { response });
          if (response.data) {
            this.$nextTick((_) => {
              this.channelId = response.data.talk_channel_id;
              document.getElementById('messagesContainer').focus();
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setCardImage(act) {
      const that = this;
      let image = new Image();
      image.src = act.activity.images.bg ? act.activity.images.bg : ''; // https://upload.wikimedia.org/wikipedia/commons/8/89/HD_transparent_picture.png

      image.onload = function () {
        if (that.loadedImagesCount === 0) {
          const desktopDivisor = that.isMobile || that.entities.length === 1 ? 1 : 2;
          const ratio = `${((image.height / image.width / desktopDivisor) * 100).toFixed(2)}%`;
          // console.log('loadedImage', ratio');
          that.imageRatioString = ratio;
        }

        that.loadedImagesCount++;
        if (that.loadedImagesCount >= that.entities.length) {
          that.showSpinner = false;
          that.loadedImagesCount = 0;
        }
      };
      return `url(${act.activity.images.bg})`;
    },
    resized() {
      console.log('resized');
      if (window.innerWidth >= 708) this.isMobile = false;
      else this.isMobile = true;
    },
    async openUsersList() {
      if (!this.showUsersList) {
        await this.apiGetUsers();
        this.showUsersList = !this.showUsersList;
      } else this.showUsersList = !this.showUsersList;
    },
  },
  beforeMount() {
    this.showSpinner = true;
    this.loadActivity();
  },
  mounted() {
    this.resized();
    window.addEventListener('resize', this.resized);
    window.addEventListener('beforeunload', this.closeWindowConfirm);
    window.addEventListener('message', this.messageReceiver);

    this.updaterInterval = setInterval(() => {
      this.loadActivity(true);
    }, 30000);

    this.$root.$on('leaveBlitzarMeeting', (data) => {
      // console.log('leaveBlitzarMeeting', { data });
      if (this.currentMetaID && data == 'public_room') {
        api
          .delete(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta/${this.currentMetaID}`)
          .then((response) => {
            console.log('apiDeleteMeta REMOVE USER response: ', { response });
            this.currentMetaID = '';
            this.$nextTick((_) => {
              this.apiGetMetaConfigs();
            });
          })
          .catch((err) => console.error(err));
      } else return;
    });

    // this.apiDeleteMeta({ meta_id: '20dbef50-bb38-11ec-b131-1779658f5d5a' });
  },
  beforeDestroy() {
    document.getElementById('zoomIframe').contentWindow.postMessage(
      {
        sender: 'logout',
        user: this.$store.state.user.name,
        language: 'pt-PT',
        msg: 'logout',
      },
      '*',
    );
    window.removeEventListener('resize', this.resized);
    window.removeEventListener('beforeunload', this.closeWindowConfirm);
    window.removeEventListener('message', this.messageReceiver);
    clearInterval(this.updaterInterval);
    this.closeModal();
  },
};
</script>
<style lang="scss">
.dm-meta-section {
  position: relative;
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  min-height: 100dvh;

  margin-top: 99px;
  @include media('<=phone') {
    margin-top: 50px;
  }
  // padding-bottom: 50px;

  &::-webkit-scrollbar {
    // display: none;
    width: 8px;
    height: 0px;
  }
  &::-webkit-scrollbar-track {
    background-color: rgb(70, 69, 66);
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(102, 102, 102) !important;
    border-radius: 4px;
    background-image: none !important;
  }
}
.meta-cards-container {
  position: relative;
  // margin-left: 320px;

  // padding: 1% 3%;
  @include media('<=phone-plus') {
    padding: 0;
  }

  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
}
.meta-activity-card {
  position: relative;
  background-position: center;
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
  min-width: 50%;
  flex-grow: 1;
  // padding-bottom: 33.3%;

  @include media('<=tablet') {
    // padding-bottom: 32vw;
  }

  @include media('<=phone-plus') {
    min-width: 360px;
    // padding-bottom: 65vw;
  }
  @include media('<=phone') {
    min-width: 340px;
  }
  // display: flex;
  // align-items: center;
  // justify-content: center;
}
.meta-activity-card-overlay {
  position: absolute;
  width: max-content;
  min-width: 280px;
  @include media('<=tablet') {
    width: 50%;
  }
  @include media('<=phone-plus') {
    width: 50%;
  }
  @include media('<=phone') {
    width: 70%;
  }
  margin: 16px 10px 10px 20px;
  padding: 14px;
  border-radius: 10px;
  color: var(--text-color);

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: blur(40px) brightness(0.7);
    backdrop-filter: blur(40px) brightness(0.7);
  }
  .card-title {
    font-size: 2rem;
  }
  .card-description {
    font-size: 1rem;
    height: max-content;
  }

  .avatars {
    position: relative;
    width: 100%;
    margin-top: 10px;
    margin-right: 16px;
    transition: all 100ms ease-in-out;

    // transform: scale(0);
    display: flex;
    flex-wrap: wrap;
  }
  button {
    // width: 100%;
    position: relative;
    margin: 10px 0 0 auto;
    padding: 8px 20px;
    background: transparent;
    color: white;
    border: 1px solid white;
    border-radius: 8px;
  }
  .stats-btn {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.avatar-cell {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 48px;
  img {
    cursor: pointer;
    position: relative;
    width: 40px;
    height: 40px;
    margin: 1px;
    margin-top: 10px;
    border-radius: 50%;
    object-fit: cover;
  }
  label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.meta-modal {
  position: relative;
  height: 100%;
  // width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  // background: teal;
}
.meta-user-profile-container {
  position: relative;
  min-width: 290px;
  min-height: 50%;
  background: #555;
  border-radius: 30px;

  padding: 40px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  img {
    width: 200px;
    height: 200px;
    object-fit: cover;
    border-radius: 50%;
  }

  label {
    margin: 10px 0;
    font-size: 2rem;
  }
}

.dm-network-widget {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.dm-network-widget-user-list-container {
  position: relative;
  width: 100%;
  max-height: 48vh;
  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: blur(20px) brightness(0.7);
    backdrop-filter: blur(20px) brightness(0.7);
  }

  @include media('<=phone-plus') {
    max-height: 86vh;
  }
  @include media('<=phone') {
    max-height: 86vh;
  }
  overflow-y: auto;
  padding: 10px 2%;
  // background: ;

  display: flex;
  flex-wrap: wrap;
  // justify-content: center;
}
.dm-network-widget-user {
  cursor: pointer;
  position: relative;
  min-width: 100px;
  margin: 10px;
  background: #444d;
  border-radius: 1000px;
  padding: 6px 24px 6px 6px;
  // box-shadow: -2px 2px 8px 0px #444;

  display: flex;
  align-items: center;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
  }
}
.dm-network-widget-user-texts {
  .user-name {
    font-size: 1.33rem;
    opacity: 0.9;
  }
  .user-role {
    font-size: 0.9rem;
    opacity: 0.55;
  }
}
.dm-network-widget-invoker-btn {
  position: relative;
  width: 100%;
  display: none;
  justify-content: center;
  // margin-bottom: 50px;
  i {
    font-size: 2.3rem;
    margin-top: 8px;
    padding: 8px;
    border-radius: 8px;
    background: #4448;
    // box-shadow: 0px 0px 8px #444;
    &:active {
      transform: scale(0.9);
    }
  }
}
.dm-network-widget-close-btn {
  position: relative;
  width: 100%;
  flex-grow: 1;
  height: 100dvh;
  z-index: 1;
}
</style>
